import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var ButtonDropdown = require("components/utility/ButtonDropdown");
var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");

var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var CurrentUser = require("lib/account/CurrentUser");

@connect(
	(state, props) => {
		// var prefs = RosterSelectors.studentListPrefs({ state }) || {};
		var prefs = {}
		var admin = RosterSelectors.admin({state, id: CurrentUser.get().id})
		
		if (admin && admin.prefs) {
			prefs = admin.prefs;
		}

		return {
			prefs
		}
	},

	(dispatch, props) => ({
		populateData: () => {
            //STEP 1: Grab logged in admin
            return Promise.all([ dispatch(RosterActions.fetchAdmins({
                filters:{ids: [CurrentUser.get().id]}, 
                embeds:['user.prefs'],
                cache: true
            }))])
        },
		onChange: (prefsUpdate, message) => {
			
			// RESETING ALL STUDENT LISTS
			var resetStudentLists = false

			if (confirm("Do you want to apply this setting to all your students? Selecting yes, will override the individual student and class preferences you may have set.") == true) {
				resetStudentLists = true
			} 

			window.wrNotifications.triggerDropDownNotification({
				title: "Information Edited", text: message, icon: "ok-sign"
			});

			return dispatch( RosterActions.updateAdminPrefs({
				id: CurrentUser.get().id,
				resetStudentLists: resetStudentLists,
				update: prefsUpdate
			}))

			// var loc = document.URL
			// 	if (loc.indexOf("roster") > -1) {
			// 		$(document).trigger('roster-update', ["updateOnly"])				
			// }
		},

	})
)

@providePopulateData({waitForLoad:true})
class OwlShopPreference extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = { openingTime: props.prefs.shop_opening_time }
		LuckyOrangeClient.tagComponent("OwlShopPreference");
	}

	onOptionChange(value, pos) {
		var preferenceHash = {};
		preferenceHash = { shop_opening_time: value };
		this.props.onChange(preferenceHash, "You successfully changed the Owl Shop settings.");
		this.setState({openingTime: value})
	}
	getOptions() {
		var options = []
		options.push(<ButtonDropdownOption onClick={ this.onOptionChange.bind(this, ALWAYS_STRING) }
						text={ ALWAYS_VALUE } key={ ALWAYS_STRING } />)
		options.push(<ButtonDropdownOption onClick={ this.onOptionChange.bind(this, NEVER_STRING) }
						text={ NEVER_VALUE } key={ NEVER_STRING } />)

		_.each(OPENING_OPTIONS, (time) => {
			var text = OPTION_LABEL + time
			options.push(<ButtonDropdownOption onClick={ this.onOptionChange.bind(this, time) }
					text={ text } key={ time } />)
		})
		return options
	}
	render() {
	
		if (this.state.openingTime != undefined) {
			var closingOptions = this.getOptions()

			if (this.state.openingTime == ALWAYS_STRING) {
				var openingTime = ALWAYS_VALUE
			} else if (this.state.openingTime == NEVER_STRING) {
				var openingTime = NEVER_VALUE
			} else {
				var openingTime = this.state.openingTime

				var disclaimer = (
					<div className="browserDisclaimer">
						<p>
							{ "The Owl Shop will be closed from 7 AM to " + openingTime  + " from Mondays to Fridays."} <br/>
						</p>
						<p>
							This setting will also apply during vacations.
						</p>
					</div>
				)
			}

			var section = (
				<div>
					<label>
						<ButtonDropdown text={ openingTime } className="standardsPicker">
							{ closingOptions }
						</ButtonDropdown>
					</label>
					{ disclaimer }
				</div>
			)
		}
		
		return (
			<div className="OwlShopPreferenceContainer">
				<p className="selectOwlShopText">
					You can close the Owl Shop and prevent your students from accessing it during class time.
				</p>
				{ section }
			</div>
		)
	}
}

var OPENING_OPTIONS = ["1 PM", "2 PM", "3 PM", "4 PM", "5 PM", "6 PM", "7 PM"]
var ALWAYS_VALUE = "Always leave open"
var ALWAYS_STRING = "Always"
var NEVER_VALUE = "Close permanently"
var NEVER_STRING = "Never"
var OPTION_LABEL = "Open shop after "

OwlShopPreference.propTypes = StrictPropTypes({
	onChange: PropTypes.func.isRequired,
	populateData: PropTypes.func.isRequired,
	prefs: PropTypes.object.isRequired
});

module.exports = OwlShopPreference;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/preferences/OwlShopPreference.js